import React from 'react';
import { Button, SpinnerContainer } from '../detail-tickets/issue-chat/IssueChat.styles';
import Spinner from 'components/spinner';
import { Icon } from 'semantic-ui-react';

const DevLiveButton = ({ title1, title2, isLoading, onClickRoute }) => {
  return (
    <Button loading={isLoading}>
      <button type="button">
        <p onClick={() => onClickRoute('dev')}>{title1}</p>
        <span> | </span>
        <p onClick={() => onClickRoute('live')}>{title2}</p>
        {isLoading && (
          <SpinnerContainer>
            <Spinner color="white" />
          </SpinnerContainer>
        )}
        <Icon name="sign-in" />
      </button>
    </Button>
  );
};
export default DevLiveButton;
